import { messages } from '@/shared/i18n';

import { TOP_BAR_SEARCH_ICON_SRC } from './constants';
import type { TopBarVariant } from './types';

const tc = messages.common;

interface AppTopBarSearchProps {
  variant: TopBarVariant;
  isGuardianDashboard: boolean;
}

/**
 * Search UI is hidden on guardian routes except for a screen-reader hint on the dashboard.
 */
export function AppTopBarSearch({ variant, isGuardianDashboard }: AppTopBarSearchProps) {
  if (variant === 'guardian') {
    return isGuardianDashboard ? <span className="sr-only">{tc.searchPlaceholder}</span> : null;
  }

  return (
    <>
      <label className="sr-only" htmlFor="app-topbar-search">
        {tc.searchPlaceholder}
      </label>
      <div className="relative max-w-[370px]">
        <input
          id="app-topbar-search"
          type="search"
          placeholder={tc.searchPlaceholder}
          disabled
          readOnly
          className="h-10 w-full rounded-[22px] border border-stroke bg-white py-2 pl-3.5 pr-11 text-sm text-ink placeholder:text-ink-soft disabled:cursor-not-allowed"
        />
        <span
          className="pointer-events-none absolute right-3.5 top-1/2 size-4 -translate-y-1/2 opacity-55"
          aria-hidden
        >
          <img src={TOP_BAR_SEARCH_ICON_SRC} alt="" className="size-full object-contain" />
        </span>
      </div>
    </>
  );
}
